<!--
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2019-12-09 19:09:57
 * @LastEditors: mrh
 * @LastEditTime: 2020-10-10 16:06:07
 -->
 
<template>
  <div id="app">
    <!--  -->
    <h5-header
      :header-show="show"
      v-show="$store.getters.ambientType!=0 && !$route.meta.hiddenHeader && !appHidden"
    ></h5-header>
    <!-- 缓存的页面	 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <!-- 不缓存的页面 -->
    <router-view v-if="!$route.meta.keepAlive" />
    <tab-bars v-if="show"></tab-bars>
  </div>
</template>

<script>
import h5Header from "@/components/header/header"
import tabBars from "./view/tabbar.vue";
export default {
  name: "app",
  components: {
    tabBars,
    h5Header
  },
  data() {
    return {
      show: false,
      appHidden: false,
    };
  },
  watch: {
    "$route":{
      handler: function (newVal, oldVal) {
        if(newVal.query.type=='app' || newVal.query.app){
          this.appHidden = true;
        }else{
          this.appHidden = false;
        }
      },
      deep: true,
      immediate: true
    },
    "$route.path": function (newVal, oldVal) {
      console.log('$route.path===', newVal);
      if (newVal == "/shops" || newVal == "/search" || newVal == "/personal") {
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  /* touch-action: pan-y; */
}
html,
body {
  height: 100%;
}
input,
textarea {
  border: none;
  line-height: normal;
}
body {
  background-color: #ffffff;
}
.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.container {
  display: flex;
  flex-direction: column;
}
#app {
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1d1d1d;
}
.van-dialog__message {
  font-size: 17px !important;
}
.van-dialog {
  /* background: none; */
  z-index: 9999 !important;
  border-radius: 5px !important;
}
.van-dialog .van-button {
  border-top: 1.04px solid #dcdcdc !important;
}
.van-dialog .van-button:first-child {
  border-right: 1.04px solid #dcdcdc !important;
}
.van-dialog .van-button:last-child {
  border-left: 0px solid #dcdcdc !important;
}
/* border兼容低版本的安卓机 */
.van-hairline--bottom::after {
  border-bottom-width: 1.04px !important;
}
.van-checkbox__icon .van-icon {
  border-width: 1.04px !important;
}
.van-button {
  border-width: 1.04px !important;
}
.van-dialog__message--has-title {
  color: #1d1d1d !important;
}
/* 我的商品编辑页弹窗特定样式 */
.know {
  z-index: 99999 !important;
}
.overlays {
  z-index: 9995 !important;
}
.van-toast {
  z-index: 9999 !important;
}
.van-field__control:disabled {
  color: #333333 !important;
  -webkit-text-fill-color: inherit !important;
}
</style>
